import React from 'react';

export default () => <div>Loading...</div>;
